import { useAppSelector } from "@/state/hooks";
import {
  Image,
  Box,
  Text,
  Link,
  useMediaQuery,
  Button,
} from "@chakra-ui/react";
import copyToClipboard from "copy-to-clipboard";
import { toastTip } from "@/components/ui/toast";

import {
  getAmount,
  getNote,
  browserUrl,
  getTitle,
  getTime,
  getStatusString,
} from "@/pages/historyBill/helpers/func/billShowData";
import { useI18n } from "@/hooks/useI18n";
import { useNavigate } from "react-router-dom";
import "./index.scss";

import { BILL_APPROVING } from "@/pages/historyBill/helpers/constants/billStatusName";

const BillDetail = (props) => {
  // 小于739
  const [isSmaller] = useMediaQuery("(max-width: 739px)");

  const { t } = useI18n();
  const navigate = useNavigate();

  const _lang = useAppSelector((state) => state.user.language);

  const { showAlert, getInfo, closeEvent } = props;

  const fiatArr = ["fiat_deposit", "fiat_withdraw"];

  const closeAlert = () => {
    closeEvent();
  };
  // 复制
  const clickCopy = (getValue) => {
    copyToClipboard(getValue);
    toastTip(t("gXbirwakdsaUKBglwK"), { type: "success" });
  };

  const detailUnitDom = (getObject) => {
    return (
      <Box
        mt={getObject.mt}
        display={"flex"}
        justifyContent={"space-between"}
        fontSize={"14px"}
        fontWeight={400}
      >
        <Text color={"#7B7C8F"} mr="17px">
          {getObject.title}
        </Text>
        {getObject?.content && (
          <Text
            color={"#010313"}
            flex={1}
            wordBreak="break-word"
            textAlign={"right"}
          >
            {getObject.content}
          </Text>
        )}
        {getObject?.url && (
          <Link color="blue.100" href={getObject?.url} isExternal>
            {t("YrkgVnAQcYRhGGRex")}
          </Link>
        )}
        {getObject?.canCopy && (
          <Box
            flex={1}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"flex-end"}
          >
            <Text
              color={"#010313"}
              flex={1}
              wordBreak="break-word"
              textAlign={"right"}
            >
              {getObject.copyContent}
            </Text>
            <Box
              p="3px"
              backgroundColor={"rgba(32, 26, 85, 0.05)"}
              borderRadius="6px"
              ml="10px"
            >
              <Image
                src="../wwwsite/images/copy.svg"
                alt="Dan Abramov"
                cursor={"pointer"}
                onClick={() => {
                  clickCopy(getObject.copyContent);
                }}
              />
            </Box>
          </Box>
        )}
      </Box>
    );
  };
  return (
    showAlert && (
      <div
        className={`bill-detail-page ${isSmaller ? "bill-detail-h5-page" : ""}`}
        onClick={closeAlert}
      >
        <div className="bill-detail-alert" onClick={(e) => e.stopPropagation()}>
          <div className="bill-detail-alert-header">
            <Image
              boxSize="24px"
              src="../wwwsite/images/bill/close.svg"
              cursor={"pointer"}
              onClick={closeAlert}
            />
          </div>
          <Box>
            <Box
              color={"#010313"}
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
            >
              <Text
                fontSize={"32px"}
                fontWeight={600}
                color={getInfo.status === "FROZEN_CONFIRMED" && "red.100"}
              >
                {getAmount(getInfo)}
              </Text>
              <Text
                fontSize={"12px"}
                fontWeight={400}
                ml="5px"
                color={getInfo.status === "FROZEN_CONFIRMED" && "red.100"}
              >
                {getInfo.currency}
              </Text>
            </Box>
            <Box
              mt="10px"
              display={"flex"}
              justifyContent={"center"}
              flexDirection={"column"}
              alignItems={"center"}
            >
              <Text
                color={
                  getInfo.status === "FROZEN_CONFIRMED" ||
                  getInfo.status === "FROZEN"
                    ? "red.100"
                    : getInfo.status === "ADMIN_REQUIRED"
                    ? "#F89753"
                    : "blue.100"
                }
              >
                {getStatusString(getInfo, t)}
              </Text>
              {/* 冻结 */}
              {/* {getInfo?.status === "FROZEN" && (
                <Button
                  h="30px"
                  fontSize="12px"
                  justifyContent={"center"}
                  color="#fff"
                  borderRadius={"20px"}
                  bg="blue.100"
                  padding={"4px 10px"}
                  textAlign={"center"}
                  _hover={{ bg: "blue.80" }}
                  mt="15px"
                  onClick={() =>
                    navigate(
                      `/trade/verify/txAddress?address=${getInfo?.transaction_id}`
                    )
                  }
                >
                  {t("BbqJaDHRCDmiNwNVcGB")}
                </Button>
              )} */}
              {/* 充值失败 */}
              {getInfo?.status === "FROZEN_CONFIRMED" &&
                getInfo?.transfer_status === "in" && (
                  <Text
                    color={"#010313"}
                    className="frozen_confirmed"
                    fontSize={"14px"}
                    mt={"25px"}
                    dangerouslySetInnerHTML={{
                      __html: t("CRbVirgSccJqKzSUSEau"),
                    }}
                  ></Text>
                )}
            </Box>
            {/* 账户划转 */}
            {getInfo?.category === "account_transfer" && (
              <Box
                w="100%"
                bgColor="rgba(32, 26, 85, 0.05)"
                borderRadius="12px"
                mt="30px"
                px="10px"
                py="10px"
                display="flex"
                alignItems="center"
                justifyContent={"center"}
              >
                <svg
                  style={{ marginRight: "5px" }}
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <circle cx="10" cy="10" r="10" fill="#333BF5" />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.4896 9.3221C15.1462 9.38813 15.6856 8.81128 15.5757 8.16058L15.1221 5.47456C15.0393 4.98482 14.4314 4.8019 14.0922 5.16468L13.2896 6.02299C12.9009 5.62448 12.4364 5.2902 11.903 5.04499C9.38174 3.88578 6.42454 5.17891 5.23769 7.76032L4.90351 8.48718L6.35723 9.15555L6.69141 8.42869C7.55849 6.54277 9.61956 5.75612 11.2347 6.4987C11.6049 6.66892 11.9273 6.90592 12.1951 7.19353L11.401 8.04272C11.0618 8.4055 11.285 8.99981 11.7792 9.04951L14.4896 9.3221Z"
                    fill="white"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.37404 10.6917C4.71413 10.6914 4.23484 11.319 4.40897 11.9556L5.14505 14.6463C5.2761 15.1254 5.89923 15.2469 6.20066 14.8521L6.80502 14.0606C7.17644 14.4229 7.61297 14.7281 8.10912 14.9562C10.6304 16.1154 13.5876 14.8223 14.7745 12.2408L15.1087 11.514L13.6549 10.8456L13.3208 11.5725C12.4537 13.4584 10.3926 14.245 8.77749 13.5025C8.39323 13.3258 8.06049 13.0772 7.78692 12.7747L8.6402 11.6573C8.94162 11.2625 8.66031 10.6934 8.16363 10.6931L5.37404 10.6917Z"
                    fill="white"
                  />
                </svg>
                <Text fontSize={16} fontWeight={600}>
                  {t("Account Transfer")}
                </Text>
              </Box>
            )}

            {getInfo?.address && getInfo?.category !== "account_transfer" && (
              <Box
                w="100%"
                bgColor="rgba(32, 26, 85, 0.05)"
                borderRadius="12px"
                mt="30px"
                px="10px"
                py="10px"
                display="flex"
                alignItems="center"
                justifyContent={
                  getInfo.is_external ? "space-between" : "center"
                }
              >
                {getInfo.is_external ? (
                  <>
                    <Text
                      color="#010313"
                      fontSize="12px"
                      fontWeight="400"
                      wordBreak="break-word"
                    >
                      {getInfo.address}
                    </Text>
                    <Image
                      src="../wwwsite/images/copy.svg"
                      alt="Dan Abramov"
                      cursor={"pointer"}
                      onClick={() => {
                        clickCopy(getInfo.address);
                      }}
                    />
                  </>
                ) : (
                  <>
                    <Image
                      borderRadius="full"
                      boxSize="30px"
                      src={getInfo.icon_url}
                      fallbackSrc="../wwwsite/images/transfer/header_icon.svg"
                      alt="currencyIcon"
                      mr="10px"
                    />
                    <Text className="text-overflow">{t(getInfo.address)}</Text>
                  </>
                )}
              </Box>
            )}
          </Box>
          <Box>
            {getInfo?.service_fee &&
              Number(getInfo?.service_fee) !== 0 &&
              detailUnitDom({
                title: t("xUNmcszdZBWMTcxnI"),
                content: `${getAmount(getInfo, "service_fee", true)} ${
                  getInfo.currency
                }`,
                mt: "30px",
              })}
            {getNote(getInfo, t) &&
              detailUnitDom({
                title: t("gZgeimlXmokhLdRziw"),
                content: getNote(getInfo, t),
                mt: "20px",
              })}
            {getInfo?.is_external &&
              !fiatArr.includes(getInfo.type) &&
              browserUrl(getInfo) &&
              detailUnitDom({
                title: t("moirunBAysHLMEDtBxUt"),
                content: "",
                mt: "20px",
                url: browserUrl(getInfo),
              })}
            <div className="bill-detail-alert-line"></div>
            {detailUnitDom({
              title: t("iuOLeRpygvfPFDnf"),
              content: getTitle(getInfo, _lang, t, true),
              mt: "20px",
            })}
            {/* 账户划转  账户*/}
            {getInfo?.category === "account_transfer" &&
              detailUnitDom({
                title: t("account"),
                content: JSON.parse(getInfo?.attach)?.account_email,
                mt: "20px",
              })}
            {detailUnitDom({
              title: t("iuswsIRQwNAIuOzoFX"),
              content: getTime(getInfo.bill_created_at, "YYYY-MM-DD HH:mm:ss"),
              mt: "20px",
            })}
            {getInfo?.transaction_id &&
              detailUnitDom({
                title:
                  getInfo?.is_external && !fiatArr.includes(getInfo?.type)
                    ? t("sBFILAqpJhAnTLlpQ")
                    : t("xqhbTjIzOYuCUiHEUmd"),
                mt: "20px",
                canCopy: true,
                copyContent: getInfo.transaction_id,
              })}
            {getInfo.status === "SUCCESS" &&
              getInfo?.updated_at &&
              getInfo?.category !== "account_transfer" &&
              detailUnitDom({
                title: t("FgrxZUNDleeDGneKmwd"),
                content: getTime(getInfo?.updated_at, "YYYY-MM-DD HH:mm:ss"),
                mt: "20px",
              })}
          </Box>
          {getInfo?.is_big_deal && getInfo?.status === BILL_APPROVING && (
            <Text textAlign={"center"} fontSize={"14px"} mt="20px">
              {t("bbQJHoMWXkEHQuVRSsO")}
            </Text>
          )}
        </div>
      </div>
    )
  );
};

export default BillDetail;
